"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetchHelper = _interopRequireDefault(require("../../util/fetchHelper"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
const getOffer = async offerId => {
  const API_URL = (0, _environmentHelper.default)();
  const url = "".concat(API_URL, "/v2/offers/").concat(offerId);
  return (0, _fetchHelper.default)(url, {
    method: 'GET'
  }).then(async res => {
    const {
      responseData,
      errors
    } = await res.json();
    if (!res.ok) {
      throw new Error(errors[0]);
    }
    return responseData;
  }).catch(err => {
    throw new Error(err);
  });
};
var _default = exports.default = getOffer;